const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5115/api";

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const text = await res.text();
    let message = `Fehler: ${res.status}`;
    try { message = JSON.parse(text)?.fehler ?? message; } catch {}
    throw new Error(message);
  }
  if (res.status === 204) return null;
  const text = await res.text();
  if (!text) return null;
  try { return JSON.parse(text); } catch { return text; }
}

export const api = {
  auth: {
    login:          (data) => request("/auth/login",           { method: "POST", body: JSON.stringify(data) }),
    register:       (data) => request("/auth/register",        { method: "POST", body: JSON.stringify(data) }),
    changePassword: (data) => request("/auth/changepassword",  { method: "POST", body: JSON.stringify(data) }),
    adminRegister:  (data) => request("/auth/admin-register",  { method: "POST", body: JSON.stringify(data) }),
    forgotPassword: (data) => request("/auth/forgot-password", { method: "POST", body: JSON.stringify(data) }),
    resetPassword:  (data) => request("/auth/reset-password",  { method: "POST", body: JSON.stringify(data) }),
  },
  produkte: {
    getAll:             ()          => request("/produkte"),
    getAllAdmin:         ()          => request("/produkte"),
    toggleVerfuegbar:   (id, val)   => request(`/produkte/${id}/verfuegbar`,   { method: "PATCH", body: JSON.stringify(val) }),
    updatePreis:        (id, preis) => request(`/produkte/${id}/preis`,        { method: "PATCH", body: JSON.stringify(preis) }),
    uploadBild: (id, file) => {
      const form = new FormData();
      form.append("bild", file);
      return fetch(`${BASE_URL}/produkte/${id}/bild`, { method: "POST", body: form })
        .then(r => r.ok ? r.json() : Promise.reject(r));
    },
    deleteBild: (id) => request(`/produkte/${id}/bild`, { method: "DELETE" }),
    updateMindestMenge: (id, menge) => request(`/produkte/${id}/mindestmenge`, { method: "PATCH", body: JSON.stringify(menge) }),
    updateAbholPreis:   (id, preis) => request(`/produkte/${id}/abholpreis`,   { method: "PATCH", body: JSON.stringify(preis) }),
  },
  betriebsurlaub: {
    getAll:  ()     => request("/betriebsurlaub"),
    create:  (data) => request("/betriebsurlaub",      { method: "POST",   body: JSON.stringify(data) }),
    delete:  (id)   => request(`/betriebsurlaub/${id}`, { method: "DELETE" }),
  },
  kunden: {
    getAll: () => request("/kunden"),
    getById: (id) => request(`/kunden/${id}`),
    create: (data) => request("/kunden", { method: "POST", body: JSON.stringify(data) }),
    update: (id, data) => request(`/kunden/${id}`, { method: "PUT", body: JSON.stringify(data) }),
    getSepa: (userId) => request(`/auth/users/${userId}/sepa`),
    updateSepa: (userId, data) => request(`/auth/users/${userId}/sepa`, { method: "PATCH", body: JSON.stringify(data) }),
    updateUser:       (userId, data) => request(`/auth/users/${userId}`,          { method: "PATCH", body: JSON.stringify(data) }),
    updateAdresse:    (userId, data) => request(`/auth/users/${userId}/adresse`,  { method: "PATCH", body: JSON.stringify(data) }),
    passwortReset:    (userId, pw)   => request(`/auth/users/${userId}/passwort`, { method: "PATCH", body: JSON.stringify({ neuesPasswort: pw }) }),
    deaktivieren:     (userId)       => request(`/auth/users/${userId}/deaktivieren`, { method: "PATCH" }),
    reaktivieren:     (userId)       => request(`/auth/users/${userId}/reaktivieren`, { method: "PATCH" }),
  },
  bestellungen: {
    getAll:       ()           => request("/bestellungen"),
    updateStatus: (id, status) => request(`/bestellungen/${id}/status`, { method: "PATCH", body: JSON.stringify(status) }),
    update:       (id, data)   => request(`/bestellungen/${id}`,        { method: "PATCH", body: JSON.stringify(data) }),
  },
  milchproduktion: {
    getAll: () => request("/milchproduktion"),
    create: (data) => request("/milchproduktion", { method: "POST", body: JSON.stringify(data) }),
  },
  mail: {
    sendAll:     (data) => request("/mail/sendall",     { method: "POST", body: JSON.stringify(data) }),
    sendWerbung: (data) => request("/mail/sendwerbung", { method: "POST", body: JSON.stringify(data) }),
  },
  besichtigungen: {
    getAll:       ()     => request("/besichtigungen"),
    getByUser:    (userId) => request(`/besichtigungen/user/${userId}`),
    create:       (data) => request("/besichtigungen",           { method: "POST",  body: JSON.stringify(data) }),
    updateStatus: (id, data) => request(`/besichtigungen/${id}/status`, { method: "PATCH", body: JSON.stringify(data) }),
    delete:       (id)   => request(`/besichtigungen/${id}`,     { method: "DELETE" }),
  },
  abos: {
    getByUser:      (userId) => request(`/abos/user/${userId}`),
    create:         (data)   => request("/abos",                  { method: "POST",   body: JSON.stringify(data) }),
    pausieren:      (data)   => request("/abos/pausieren",        { method: "POST",   body: JSON.stringify(data) }),
    pauseAufheben:  (aboId)  => request("/abos/pause-aufheben",   { method: "POST",   body: JSON.stringify({ aboId }) }),
    aendern:        (data)   => request("/abos/aendern",          { method: "PUT",    body: JSON.stringify(data) }),
    beenden:        (id)     => request(`/abos/${id}/beenden`,    { method: "PATCH" }),
    getAusnahmen:   (userId) => request(`/abos/ausnahmen/user/${userId}`),
    addAusnahme:    (data)   => request("/abos/ausnahmen",        { method: "POST",   body: JSON.stringify(data) }),
    removeAusnahme: (data)   => request("/abos/ausnahmen",        { method: "DELETE", body: JSON.stringify(data) }),
  },
  payment: {
    rechnungAbo: (data) => request("/payment/rechnung-abo", { method: "POST", body: JSON.stringify(data) }),
  },
  analyse: {
    getKpis: () => request("/analyse/kpis"),
  },
  events: {
    getAll:      ()        => request("/events"),
    create:      (data)    => request("/events",             { method: "POST",   body: JSON.stringify(data) }),
    toggleAktiv: (id, val) => request(`/events/${id}/aktiv`, { method: "PATCH",  body: JSON.stringify(val) }),
    delete:      (id)      => request(`/events/${id}`,       { method: "DELETE" }),
  },
  rabattcodes: {
    getAll:      ()        => request("/rabattcodes"),
    create:      (data)    => request("/rabattcodes",             { method: "POST",   body: JSON.stringify(data) }),
    toggleAktiv: (id, val) => request(`/rabattcodes/${id}/aktiv`, { method: "PATCH",  body: JSON.stringify(val) }),
    delete:      (id)      => request(`/rabattcodes/${id}`,       { method: "DELETE" }),
  },
  gutscheine: {
    getAll:      ()          => request("/gutscheine"),
    create:      (data)      => request("/gutscheine",          { method: "POST",   body: JSON.stringify(data) }),
    toggleAktiv: (id, val)   => request(`/gutscheine/${id}/aktiv`, { method: "PATCH", body: JSON.stringify(val) }),
    delete:      (id)        => request(`/gutscheine/${id}`,    { method: "DELETE" }),
  },
  flaschen: {
    getAll:    ()            => request("/flaschen"),
    getByUser: (userId)      => request(`/flaschen/user/${userId}`),
    setAnzahl: (userId, n)   => request(`/flaschen/${userId}`,      { method: "PATCH", body: JSON.stringify({ anzahl: n }) }),
    addAnzahl: (userId, d)   => request(`/flaschen/${userId}/add`,  { method: "PATCH", body: JSON.stringify({ delta: d }) }),
  },
  fahrer: {
    getLieferungen: (datum)           => request("/fahrer/lieferungen?datum=" + datum),
    geliefert:      (id, datum)       => request(`/fahrer/bestellung/${id}/geliefert?datum=${datum}`, { method: "PATCH" }),
    leergut:        (id, abgeholt)    => request(`/fahrer/bestellung/${id}/leergut`,   { method: "PATCH", body: JSON.stringify({ abgeholt }) }),
  },
  fahrerTourenPlan: {
    get:              (jahr, monat)            => request(`/fahrertourenplan?jahr=${jahr}&monat=${monat}`),
    setzen:           (datum, tourId, userId)  => request("/fahrertourenplan", { method: "PUT", body: JSON.stringify({ datum, tourId, userId }) }),
    setDauer:         (id, dauerMinuten)       => request(`/fahrertourenplan/${id}/dauer`, { method: "PATCH", body: JSON.stringify(dauerMinuten) }),
    stundenubersicht: (jahr, monat)            => request(`/fahrertourenplan/stundenubersicht?jahr=${jahr}&monat=${monat}`),
  },
  tagesbedarf: {
    getByDatum: (datum) => request("/tagesbedarf?datum=" + datum),
  },
  rechnungen: {
    getAll: (monat, nurOffene) => {
      const params = new URLSearchParams();
      if (monat) params.set("monat", monat);
      if (nurOffene) params.set("nurOffene", "true");
      const qs = params.toString();
      return request("/rechnungen" + (qs ? "?" + qs : ""));
    },
    generieren:          ()         => request("/rechnungen/generieren",          { method: "POST" }),
    updateStatus:        (id, s)    => request(`/rechnungen/${id}/status`,         { method: "PATCH",  body: JSON.stringify(s) }),
    delete:              (id)       => request(`/rechnungen/${id}`,                { method: "DELETE" }),
    pdf:                 (id)       => `${BASE_URL}/rechnungen/${id}/pdf`,
    sendMail:            (id)       => request(`/rechnungen/${id}/mail`,           { method: "POST" }),
    mahnen:              (id)       => request(`/rechnungen/${id}/mahnen`,         { method: "POST" }),
    freigeben:           (id)       => request(`/rechnungen/${id}/freigeben`,      { method: "POST" }),
    alleFreigeben:       ()         => request("/rechnungen/alle-freigeben",       { method: "POST" }),
    manuellErstellen:    (dto)      => request("/rechnungen/manuell",              { method: "POST",   body: JSON.stringify(dto) }),
    monatlichVersenden:  ()         => request("/rechnungen/monatlich-versenden",  { method: "POST" }),
    painExport:          ()         => `${BASE_URL}/rechnungen/pain-export`,
    camtImport: (formData) =>
      fetch(`${BASE_URL}/rechnungen/camt-import`, { method: "POST", body: formData })
        .then(async r => {
          if (!r.ok) { const t = await r.text(); let m = `Fehler ${r.status}`; try { m = JSON.parse(t)?.fehler ?? m; } catch {} throw new Error(m); }
          return r.json();
        }),
  },
  nachrichten: {
    getAll: () => request("/nachrichten"),
    create: (data) => request("/nachrichten", { method: "POST", body: JSON.stringify(data) }),
    alsGelesen: (id) => request(`/nachrichten/${id}/gelesen`, { method: "PATCH" }),
    delete: (id) => request(`/nachrichten/${id}`, { method: "DELETE" }),
  },
  einstellungen: {
    get: (key) =>
      request(`/einstellungen/${key}`)
        .then(r => {
          if (r === null || r === undefined) return null;
          if (typeof r === "object") return JSON.stringify(r);
          return r || null;
        })
        .catch(() => null),
    update: (key, wert) =>
      request(`/einstellungen/${key}`, { method: "PATCH", body: JSON.stringify(wert) }),
  },
  manuelleBestellung: {
    create: (data) => request("/manuellebestellung", { method: "POST", body: JSON.stringify(data) }),
  },
  touren: {
    getAll:         ()                    => request("/touren"),
    create:         (data)                => request("/touren",               { method: "POST",   body: JSON.stringify(data) }),
    update:         (id, data)            => request(`/touren/${id}`,         { method: "PUT",    body: JSON.stringify(data) }),
    delete:         (id)                  => request(`/touren/${id}`,         { method: "DELETE" }),
    toggleAktiv:    (id, val)             => request(`/touren/${id}/aktiv`,   { method: "PATCH",  body: JSON.stringify(val) }),
    getPLZ:         (id)                  => request(`/touren/${id}/plz`),
    addPLZ:         (id, dto)             => request(`/touren/${id}/plz`,     { method: "POST",   body: JSON.stringify(dto) }),
    deletePLZ:      (plzId)               => request(`/touren/plz/${plzId}`,  { method: "DELETE" }),
    fuerDatum:      (datum)               => request("/touren/fuerDatum?datum=" + datum),
    getLieferungen: (id, datum)           => request("/touren/" + id + "/lieferungen?datum=" + datum),
    getOhneTour:    ()                    => request("/touren/ohnetour"),
    setManuelTour:    (bestellungId, tourId) => request(`/touren/bestellung/${bestellungId}/tour`, { method: "PATCH", body: JSON.stringify({ tourId }) }),
  },
  inventar: {
    getAll:            ()              => request("/inventar"),
    getFlaschenTypen:  ()              => request("/inventar/flaschentypen"),
    setTyp:            (pid, typId)    => request(`/inventar/${pid}/typ`,                    { method: "PUT",   body: JSON.stringify(typId) }),
    setGesamtAnzahl:   (typId, anz)    => request(`/inventar/flaschentypen/${typId}/anzahl`, { method: "PATCH", body: JSON.stringify(anz) }),
  },
  news: {
    getAll:      (nurAktiv) => request("/news" + (nurAktiv ? "?nurAktiv=true" : "")),
    create:      (data)             => request("/news",             { method: "POST",   body: JSON.stringify(data) }),
    update:      (id, data)         => request(`/news/${id}`,       { method: "PUT",    body: JSON.stringify(data) }),
    toggleAktiv: (id, val)          => request(`/news/${id}/aktiv`, { method: "PATCH",  body: JSON.stringify(val) }),
    delete:      (id)               => request(`/news/${id}`,       { method: "DELETE" }),
  },
  regiomaten: {
    getAll: ()       => request("/regiomaten"),
    create: (data)   => request("/regiomaten",       { method: "POST",   body: JSON.stringify(data) }),
    update: (id, data) => request(`/regiomaten/${id}`, { method: "PUT",  body: JSON.stringify(data) }),
    delete: (id)     => request(`/regiomaten/${id}`, { method: "DELETE" }),
  },
  dienstplan: {
    get:               (typ, jahr, monat) => request(`/dienstplan?typ=${typ}&jahr=${jahr}&monat=${monat}`),
    save:              (dto)              => request("/dienstplan", { method: "PUT", body: JSON.stringify(dto) }),
    delete:            (id)               => request(`/dienstplan/${id}`, { method: "DELETE" }),
    verfuegbareMonate: (typ)              => request(`/dienstplan/verfuegbare-monate?typ=${typ}`),
  },
};
